module.exports = __webpack_public_path__ + "img/background.6abb8bd8.png";